module.exports = __webpack_public_path__ + "img/symbol_13_x6.6cfc69d2.png";